import React from 'react';
import { HrParagraph } from '@components/styles/hr-styles';

export const eventTemplates = {
  approved: (username, requestName) => (
    <HrParagraph>
      <strong>{username}</strong> ha aprobado la solicitud de vacante <strong>{requestName}</strong>.
    </HrParagraph>
  ),
  create: (username, requestName) => (
    <HrParagraph>
      Ha ingresado una nueva solicitud de vacante <strong>{requestName}</strong> enviada por <strong>{username}</strong>
      .
    </HrParagraph>
  ),
  update_request: (username, requestName, comment) => (
    <HrParagraph>
      <strong>{username}</strong> ha solicitado modificaciones en la solicitud de vacante <strong>{requestName}</strong>
      {comment && ` y añadió el siguiente mensaje “${comment}”`}.
    </HrParagraph>
  ),
  updated: (username, requestName) => (
    <HrParagraph>
      <strong>{username}</strong> ha modificado la solicitud de vacante <strong>{requestName}</strong>.
    </HrParagraph>
  ),
  rejected: (username, requestName, comment) => (
    <HrParagraph>
      <strong>{username}</strong> ha rechazado la solicitud de vacante <strong>{requestName}</strong>
      {comment && ` y añadió el siguiente mensaje “${comment}”`}.
    </HrParagraph>
  ),
  deleted: (username, requestName) => (
    <HrParagraph>
      <strong>{username}</strong> ha eliminado la solicitud de vacante <strong>{requestName}</strong>
    </HrParagraph>
  )
};
